// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1CL6u","left":"InfoRow_left__2xCdY"};